import { asyncScheduler, scheduled, Subject } from 'rxjs';
/**
 * 服务总线客户端
 */
export class ServiceBusClient {
    constructor(serverAppName, serviceBus) {
        this._initialized = new Subject();
        this._serviceBus = serviceBus;
        this.serverAppName = serverAppName;
    }
    /**
     * 服务事件
     *
     */
    get serverEvents() {
        var _a;
        return (_a = this._serviceBusServer) === null || _a === void 0 ? void 0 : _a.events;
    }
    /**
     * 初始化
     */
    init() {
        if (!this._serviceBus) {
            throw new Error('ServiceBus is null');
        }
        this._serviceBusServer = this._serviceBus.getServer(this.serverAppName);
        if (this._serviceBusServer) {
            this.initState = 'success';
            return scheduled(this.initState, asyncScheduler);
        }
        this.initState = 'fail';
        if (this._serverRegisteredSubscription) {
            return this._initialized;
        }
        this._serverRegisteredSubscription = this._serviceBus.serverRegistered.subscribe((servers) => {
            if (!servers) {
                return;
            }
            if (servers.appName === this.serverAppName) {
                this._serverRegisteredSubscription.unsubscribe();
                this.initState = 'success';
                this._serviceBusServer = servers;
                this._initialized.next(this.initState);
                this._initialized.complete();
                return;
            }
        });
        return this._initialized;
    }
    /**
     * 发送请求
     */
    request(event) {
        if (!event) {
            throw new Error(`request ServiceBusEvent event cannot be null`);
        }
        if (event.isRequest === false) {
            throw new Error(`ServiceBusEvent isRequest cannot be false when request`);
        }
        if (!this._serviceBusServer) {
            throw new Error(`serviceBusServer is null`);
        }
        if (!this._serviceBusServer.requestHandler) {
            throw new Error(`server app ${this.serverAppName} not implement requestHandler`);
        }
        event.isRequest = true;
        return this._serviceBusServer.requestHandler(event);
    }
    /**
     * 销毁
     */
    destroy() {
        var _a;
        (_a = this._serverRegisteredSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this._initialized.complete();
        this._serviceBusServer = undefined;
    }
}
